<template>
  <div class="lab-overlay" role="dialog" aria-modal="true" :aria-label="`Test dashboard${machineName ? ' for ' + machineName : ''}`">
    <lab-telemetry-viewer
      :run-id="runId"
      :run="run"
      :machine-name="machineName"
      :playback="playback"
      @close="$emit('close')"
    />
  </div>
</template>

<script>
import LabTelemetryViewer from './LabTelemetryViewer.vue'

// Full-screen host for the lab dashboard. The dashboard is a working surface
// with a wide multi-axis chart and a values panel, so it takes the whole
// viewport rather than the app's standard modal, which caps at 80% width and
// animates to its content's measured height.
export default {
  name: 'LabTelemetryOverlay',
  components: { LabTelemetryViewer },
  props: {
    runId: { type: String, default: null },
    run: { type: Object, default: null },
    machineName: { type: String, default: '' },
    playback: { type: Boolean, default: false }
  },
  mounted () {
    this.previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', this.onKey)
  },
  beforeDestroy () {
    document.body.style.overflow = this.previousOverflow
    window.removeEventListener('keydown', this.onKey)
  },
  methods: {
    onKey (e) {
      if (e.key === 'Escape') this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.lab-overlay {
  position: fixed;
  inset: 0;
  // Above the app shell (sidebar ≤ 20, modals 4) but below the tooltip plugin
  // (1000), so tooltips inside the dashboard still show, and below toasts and
  // the global loader (99999), so "Test finished" notices appear over it.
  z-index: 999;
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
}
</style>
